"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buchGenerateSKUCodeApi = buchGenerateSKUCodeApi;
exports.customersApi = customersApi;
exports.generateSKUCodeApi = generateSKUCodeApi;
exports.generateSPUCodeApi = generateSPUCodeApi;
exports.getCustomersApi = getCustomersApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 获取SPUCode
 */
function generateSPUCodeApi(data) {
  return (0, _request.default)({
    url: "/admin/generator/generateSPUCode",
    method: 'POST',
    data: data
  });
}
/**
 * 获取SKUCode
 */
function generateSKUCodeApi(data) {
  return (0, _request.default)({
    url: "/admin/generator/generateSKUCode",
    method: 'POST',
    data: data
  });
}

/**
 * 获取SKUCode
 */
function buchGenerateSKUCodeApi(data) {
  return (0, _request.default)({
    url: "/admin/generator/batch/generateSKUCode",
    method: 'POST',
    data: data
  });
}

/**
 * 查询客户下拉列表
 */

function getCustomersApi(params) {
  return (0, _request.default)({
    url: "/admin/customers/options",
    method: 'GET',
    params: params
  });
}

/**
 * 获取分销商
 */
function customersApi() {
  return (0, _request.default)({
    url: "/admin/customers",
    method: 'GET',
    params: {
      page: 1,
      limit: 999,
      customerType: 3
    }
  });
}